import { useState } from "react";
import {
  Button,
  Box,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Image,
  Text,
  Flex,
} from "@chakra-ui/react";
import moreImg from "./images/more.svg";
import moreActiveImg from "./images/more_active.svg";
import docsImg from "./images/docs.svg";
import referralsImg from "./images/referrals.svg";
import githubImg from "./images/github.svg";
import discordImg from "./images/discord.svg";
import twitterImg from "./images/twitter.svg";
import telImg from "./images/tel.svg";

const PcMenu = ({ moreList }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <Box
      onClick={() => setIsOpen(!isOpen)}
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
    >
      <Menu isOpen={isOpen}>
        {({ isOpen }) => (
          <>
            <MenuButton
              as={Button}
              variant="ghost"
              borderRadius="full"
              px={0}
              minW={"32px"}
              h={"32px"}
              _hover={{
                bg: "black.sombre",
              }}
              _active={{
                bg: "black.sombre",
              }}
              _focus={{
                border: "none",
              }}
            >
              <Image
                h={"32px"}
                w={"32px"}
                src={isOpen ? moreActiveImg : moreImg}
              />
            </MenuButton>

            <MenuList
              color="gray.light"
              zIndex={101}
              bgColor={"gray.desolate"}
              border="none"
              p={"12px"}
              borderRadius={"16px"}
              minWidth="0"
              fontSize="14px"
              mt={"6px"}
              ml={"-4px"}
            >
              {moreList.map((item) => (
                <MenuItem
                  borderRadius={"8px"}
                  _hover={{
                    background: "#131A24",
                  }}
                  _focus={{
                    bg: "transparent",
                  }}
                  w={"154px"}
                  p={"12px"}
                  icon={<Image minW={"20px"} src={item.icon} />}
                  onClick={item.onClick}
                >
                  {item.label}
                </MenuItem>
              ))}
            </MenuList>
          </>
        )}
      </Menu>
    </Box>
  );
};

const MobileMenu = ({ moreList }) => {
  return (
    <Box px={"4px"} w={"full"}>
      {moreList.map((item) => (
        <Flex
          _hover={{
            color: "theme.light",
          }}
          color={"gray.light"}
          h={"40px"}
          onClick={item.onClick}
          cursor={"pointer"}
          alignItems={"center"}
          gap={"12px"}
          px="28px"
        >
          <Image minW={"20px"} src={item.icon} />
          <Text fontSize={"12px"}>{item.label}</Text>
        </Flex>
      ))}
    </Box>
  );
};

export default function MoreSelector({ isMobile }) {
  const moreList = [
    {
      icon: docsImg,
      label: `Docs`,
      onClick: () => {
        window.open("https://docs.ktx.finance/", "_blank");
      },
    },
    // {
    //   icon: referralsImg,
    //   label: `Referrals`,
    //   onClick: () => {
    //     window.open("https://app.ktx.finance/referrals", "_blank");
    //   },
    // },
    {
      icon: githubImg,
      label: `Github`,
      onClick: () => {
        window.open("https://github.com/KTX-finance/KTX-core", "_blank");
      },
    },
    {
      icon: discordImg,
      label: `Discord`,
      onClick: () => {
        window.open("https://discord.com/invite/tAFgvRNxTQ", "_blank");
      },
    },
    {
      icon: twitterImg,
      label: `Twitter`,
      onClick: () => {
        window.open("https://twitter.com/KTX_finance", "_blank");
      },
    },
    {
      icon: telImg,
      label: `Telegram`,
      onClick: () => {
        window.open("https://t.me/KTX_officials", "_blank");
      },
    },
  ];

  return isMobile ? (
    <MobileMenu moreList={moreList} />
  ) : (
    <PcMenu moreList={moreList} />
  );
}
